import apiClient from './api-service';
import { AxiosResponse } from 'axios';

// Определяем режим приложения один раз при старте модуля
const isProduction = process.env.NODE_ENV === 'production';

export const fetchData = async <T>(endpoint: string): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await apiClient.get(endpoint);
        return response.data;
    } catch (error: any) {
        if (!isProduction) {
            console.error('Fetch error:', error.response?.data || error);
        }
        throw error; // Прокидываем ошибку дальше
    }
};

export const postData = async <T, D>(endpoint: string, data: D): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await apiClient.post(endpoint, data);
        return response.data;
    } catch (error: any) {
        if (!isProduction) {
            console.error('Post error:', error.response?.data || error);
        }
        throw error;
    }
};

export const updateData = async <T, D>(endpoint: string, data: D): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await apiClient.put(endpoint, data);
        return response.data;
    } catch (error: any) {
        if (!isProduction) {
            console.error('Update error:', error.response?.data || error);
        }
        throw error;
    }
};

export const deleteData = async <T>(endpoint: string): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await apiClient.delete(endpoint);
        return response.data;
    } catch (error: any) {
        if (!isProduction) {
            console.error('Delete error:', error.response?.data || error);
        }
        throw error;
    }
};

export const patchData = async <T, D>(endpoint: string, data: D): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await apiClient.patch(endpoint, data);
        return response.data;
    } catch (error: any) {
        if (!isProduction) {
            console.error('Patch error:', error.response?.data || error);
        }
        throw error;
    }
};
